import { render, staticRenderFns } from "./detailInOut.vue?vue&type=template&id=66ff4d55&scoped=true"
import script from "./detailInOut.vue?vue&type=script&lang=js"
export * from "./detailInOut.vue?vue&type=script&lang=js"
import style0 from "./detailInOut.vue?vue&type=style&index=0&id=66ff4d55&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ff4d55",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ff4d55')) {
      api.createRecord('66ff4d55', component.options)
    } else {
      api.reload('66ff4d55', component.options)
    }
    module.hot.accept("./detailInOut.vue?vue&type=template&id=66ff4d55&scoped=true", function () {
      api.rerender('66ff4d55', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/detailInOut.vue"
export default component.exports